import Constants from '../constants'
import course from './course'
import favorite from './favorite'
import genre from './genre'
import plan from './plan'
import place from './place'
import route from './route'
import station from './station'
import location from './location'
import translation from './translation'
import notice from './notice'
import ticket from './ticket'
import reservations from './reservations'
import axios from 'axios'

// jestでaxiosはmockにするのでその時はセットしない
if (axios.defaults) {
  axios.defaults.baseURL = Constants.API_BASE_URL
  axios.defaults.responseType = 'json'
}

const api = {
  ...course,
  ...genre,
  ...favorite,
  ...plan,
  ...place,
  ...route,
  ...station,
  ...location,
  ...translation,
  ...notice,
  ...ticket,
  ...reservations
}

export default api
